var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgPin = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "m6.188 8.063-1.345-5.38a.5.5 0 0 1 .485-.62h7.344a.5.5 0 0 1 .485.62l-1.344 5.38 2.074 2.963a.5.5 0 0 1-.41.787H4.523a.5.5 0 0 1-.41-.787zM9 11.813V16.5" }) }))); };
export default SvgPin;
